<template>
  <section class="grid md:grid-cols-2 gap-10 px-2 lg:px-0">
    <div>
      <label class="text-gray-900 dark:text-gold-50 font-light"
        >Tilpass kilometerstand</label
      >
      <div class="mt-2.5">
        <vue-slider
          @change="(val) => change({ key: 'kilometer', val })"
          v-model="kilometer"
          :min="0"
          :max="financial.kilometer_fees.length - 1"
          :interval="1"
          :dot-size="20"
          :piecewise="true"
          tooltip="always"
          tooltip-dir="bottom"
          :height="3"
        >
          <template v-slot:tooltip="{ value }">
            {{ financial.kilometer_fees[value].limit }} km
          </template>
        </vue-slider>
      </div>
    </div>

    <div>
      <label class="text-gray-900 dark:text-gold-50 font-light">
        Duration
      </label>
      <div class="mt-2.5">
        <vue-slider
          @change="(val) => change({ key: 'duration', val })"
          v-model="duration"
          :min="0"
          :max="financial.duration_fees.length - 1"
          :interval="1"
          :dot-size="20"
          tooltip="always"
          tooltip-dir="bottom"
          :height="3"
        >
          <template v-slot:tooltip="{ value }">
            {{ financial.duration_fees[value]?.years || '-' }} år
          </template>
        </vue-slider>
      </div>
    </div>
  </section>
</template>

<script>
import VueSlider from 'vue-slider-component';
import Helper from '../helper/FinancialHelper';

export default {
  name: 'SubscriptionCalculator',
  props: {
    financial: Object,
    optionsSum: Number,
    prevPrices: Object,
    prevOptionsSum: Number,
    shouldUpdate: Boolean,
    currentColor: Number,
  },
  components: {
    VueSlider,
  },
  data: function () {
    return {
      duration: 0,
      kilometer: 0,
      calculationsInput: null,
    };
  },
  watch: {
    financial: {
      deep: true,
      handler() {
        this.change();
      },
    },
    shouldUpdate() {
      this.change();
    },
    currentColor() {
      this.change();
    },
    optionsSum() {
      this.change();
    },
  },
  mounted() {
    this.assignDomNodes();
    this.$nextTick(() => {
      this.change();
    });
  },
  methods: {
    assignDomNodes() {
      this.calculationsInput = document.querySelector(
        '.input-car-calculations'
      );
      this.pricesInput = document.querySelector('.input-car-prices');
    },
    change(data) {
      if (data) this[data.key] = data.val;

      const starting_price = +this.financial.starting_price;
      const kilometer = this.financial.kilometer_fees[this.kilometer];
      const { optionsSum } = this;

      const duration = {
        years: +this.financial.duration_fees[this.duration]?.years,
        fee: +this.financial.duration_fees[this.duration]?.fee,
      };

      const prevDuration = {
        years: this.prevPrices
          ? +this.prevPrices.subscription.duration_fees[this.duration]?.years
          : 0,
        fee: this.prevPrices
          ? +this.prevPrices.subscription.duration_fees[this.duration]?.fee
          : 0,
      };

      const mndprice =
        Helper.calculateSubscriptionMonthlyFee(
          starting_price,
          +kilometer.fee,
          duration.fee
        ) + (optionsSum || 0);

      const totalPrice =
        Helper.calculateSubscriptionTotalPrice(
          starting_price,
          +kilometer.fee,
          duration
        ) + (optionsSum * 36 || 0);

      const prevTotalPrice = this.prevPrices
        ? Helper.calculateSubscriptionTotalPrice(
            +this.prevPrices.subscription.starting_price,
            +this.prevPrices.subscription.kilometer_fees[this.kilometer].fee,
            prevDuration
          ) + (this.prevOptionsSum * 36 || 0)
        : 0;

      const f = this.$filters.formatNumber;

      if (this.calculationsInput) {
        const str = `TYPE: subscription,
        1. Kilometers: limit - ${f(kilometer.limit)} km / fee - ${f(
          kilometer.fee
        )} NOK,
        2: Duration: years - ${f(duration.years)} / fee - ${f(
          duration.fee
        )} NOK`;
        this.calculationsInput.value = str;
      }

      if (this.pricesInput) {
        const str = `TYPE: subscription,
        1. Total Price: ${f(totalPrice)} NOK,
        2. Monthly Price: ${f(mndprice)} NOK`;
        this.pricesInput.value = str;
      }
      if (!this.shouldUpdate) return;

      this.emitter.emit('update-calculations', {
        type: 'subscription',
        mndprice,
        totalPrice,
        prevTotalPrice,
        disclaimer: this.financial.disclaimer,
      });
    },
  },
};
</script>
